<!-- Подпись инициатора с неизменяемым текстом подтверждения. -->
<template>
  <VehicleInspectionStepLayout :title="step.name || 'Распишитесь'" :description="step.description">
    <VehicleInspectionSignatureField
      ref="signatureField"
      :statement="inspection.signature_statement"
      @change="hasSignature = $event"
    />
    <template #actions>
      <base-primary-button size="large" :disabled="disabled || !hasSignature" @click="submit">Подписать и отправить участникам</base-primary-button>
    </template>
  </VehicleInspectionStepLayout>
</template>
<script>
import VehicleInspectionStepLayout from "@/components/Vehicle/Inspection/Step/Layout.vue";
import VehicleInspectionSignatureField from "@/components/Vehicle/Inspection/Signature/Field.vue";

export default {
  name: "VehicleInspectionStepSignature",
  components: { VehicleInspectionSignatureField, VehicleInspectionStepLayout },
  props: {
    step: { type: Object, required: true },
    inspection: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  emits: ["complete"],
  data() {
    return {
      hasSignature: false,
    };
  },
  methods: {
    async submit() {
      const blob = await this.$refs.signatureField.getBlob();
      if (blob) this.$emit("complete", { file: blob });
    },
  },
};
</script>
